import React from 'react';
import { reduxForm } from 'redux-form';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Grid from 'infrastructure/js/components/Grid/gridWrapper.js';
import { gridsNames } from '../../../../../enums/gridsNames';
import { filterTypes } from 'infrastructure/js/enums/filterTypes';
import LabelWithTooltipCell from '../../../../Common/CustomGridCells/LabelWithTooltipCell/labelWithTooltipCell.js';
import { FetchEntitiesFilters } from '../../../../../enums/fetchEntitiesFilters';
import { EntityPropertyTypes } from '../../../../../enums/entityPropertyTypes';
import { navigationStates } from '../../../../../enums/navigationStates';
import LastOperationCell from '../../../../Common/CustomGridCells/LastOperationCell/lastOperationCell';
import EntityIdCell from '../../../../Common/CustomGridCells/EntityIdCell/entityIdCell';
import {
  alertStatus,
  getAlertColumnFilterSections,
} from '../../../../../utils/alertFilterSectionHelper';
import AssetAlertPopoverCell from '../../../../Common/CustomGridCells/AssetAlertPopoverCell/assetAlertPopoverCell';
import ToolUsageProgressCell from '../../../../Common/CustomGridCells/ToolUsageProgressCell/toolUsageProgressCell';
import { filterAlignmentTypes } from 'infrastructure/js/enums/filterAlignmentTypes';
import ToolTypeHelper from '../../../../../utils/toolTypeHelper';
import {enumTypes, getEnumLabel} from '../../../../../utils/enumHelper';

require('./toolsGrid.scss');

class ToolsGrid extends React.PureComponent {
  filterConfig = [
    { fieldName: 'assetAlert', filterName: 'assetAlert' },
    { fieldName: 'maxNumOfCycles', filterName: '' },
    { fieldName: 'currentCyclesNumber', filterName: '' },
    { fieldName: 'toolStatus', filterName: 'toolStatus', getOptions: true },
    { fieldName: 'toolType.businessId', filterName: 'toolType', getOptions: true },
    { fieldName: 'businessId', filterName: 'businessId', getOptions: false },
    { fieldName: 'toolType.toolCategory.businessId', filterName: 'toolCategoryBusinessId', getOptions: true },
    { fieldName: 'lastOperation', filterName: 'assetLastOperationDate', getOptions: true },
    { fieldName: 'toolType.configurationType', filterName: 'configurationType', getOptions: true },
  ];

  constructor(props) {
    super(props);
    this.labels = createLabelHelper('mat.grid.');
    this.toolStatusLabels = createLabelHelper('enum.tool.status.');

    this.columnsConfig = this.createColumnsConfig();
  }

  createColumnsConfig = () => {
    return [
      {
        fieldName: 'assetAlert',
        title: this.labels.get('columns.alert.title'),
        filterType: filterTypes.MULTI_SECTIONS,
        filterName: 'assetAlert',
        filterSections: getAlertColumnFilterSections([
          alertStatus.NO_ALERT,
          alertStatus.WARNING,
          alertStatus.ERROR,
        ]),
        width: 120,
        columnOptions: {
          cellComponent: AssetAlertPopoverCell,
          valueGetter: (params) => {
            return {
              description: '',
              alerts: params.data.alerts,
              alertStatus: params.data.alertStatus,
              cyclesCount: params.data.maintenanceRemainingCycles,
              toolUsageTime: params.data.maintenanceRemainingUsageTime,
            };
          },
          sort: 'desc',
        },
      },
      {
        fieldName: 'toolType.businessId',
        title: this.labels.get('columns.type.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'toolType',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
          valueGetter: ({ data }) => {
            return ToolTypeHelper.getToolTypeFullLabel(
              data.toolType.description,
              data.toolType.businessId
            );
          },
        },
      },
      {
        fieldName: 'businessId',
        title: this.labels.get('columns.toolId.title'),
        filterType: filterTypes.MULTI_SELECT_ASYNC,
        filterName: 'businessId',
        fetchConfig: {
          entityType: EntityPropertyTypes.TOOL_BUSINESS_ID,
          filter: [FetchEntitiesFilters.ACTIVE, FetchEntitiesFilters.ON_LOCATION],
          action: this.props.actions.fetchEntities,
        },
        columnOptions: {
          cellComponent: EntityIdCell,
          valueGetter: (params) => {
            return {
              id: params.data.id,
              label: params.data.businessId,
              type: navigationStates.TOOL,
            };
          },
        },
      },
      {
        fieldName: 'toolType.toolCategory.businessId',
        title: this.labels.get('columns.toolCategory.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'toolCategoryBusinessId',
        columnOptions: {
          valueGetter: (params) => {
            return params.data.toolType?.toolCategory?.businessId || ''
          },
        },
      },
      {
        fieldName: 'lastOperation',
        title: this.labels.get('columns.lastOperation.title'),
        width: 215,
        filterType: filterTypes.NONE,
        columnOptions: {
          cellComponent: LastOperationCell,
          headerComponentParams: { headerTextStyle: { marginLeft: '0px' } },
          valueGetter: (params) => {
            return params.data.lastOperation || ''
          },
        },
      },
      {
        fieldName: 'usage',
        title: this.labels.get('columns.usage.title'),
        filterType: filterTypes.NONE,
        width: 140,
        columnOptions: {
          cellComponent: ToolUsageProgressCell,
          sortable: false,
          valueGetter: (params) => {
            
            // console.log('params ===> ', params);
            // console.log('maintenanceRemainingIntervalTime ===> ', params.data.maintenanceRemainingIntervalTime);
            // console.log('m_maintenanceData ===> ', params.data.m_maintenanceData);

            return {
              m_maintenanceData: params.data.m_maintenanceData,
              // usagePercentage: params.data.m_maintenanceData.timeBased.percentRemaining || 0,
            };
          },
        },
      },
      {
        fieldName: 'toolStatus',
        title: this.labels.get('columns.progressStatus.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterAlignment: filterAlignmentTypes.RIGHT,
        filterName: 'toolStatus',
        width: 210,
        columnOptions: {
          valueGetter: (params) => {
            return params.data.toolStatus ? this.toolStatusLabels.get(params.data.toolStatus) : '';
          },
        },
      },
      {
        fieldName: 'toolType.configurationType',
        title: this.labels.get('columns.kitTypesConfiguration.title'),
        filterType: filterTypes.MULTI_SELECT,
        filterName: 'configurationType',
        columnOptions: {
          cellComponent: LabelWithTooltipCell,
          valueGetter: (params) => {
            return getEnumLabel(enumTypes.TOOL_CONFIGURATION_TYPE)(params.data.toolType?.configurationType);
          },
        }
      },
    ];
  };

  getRowHeight() {
    return 100;
  }

  render() {
    return (
      <div className="tools-grid">
        <Grid
          gridName={gridsNames.LOCATION_ASSET_TOOLS}
          columnsConfig={this.columnsConfig}
          actions={this.props.actions}
          filterConfig={this.filterConfig}
          gridProps={{
            getRowHeight: this.getRowHeight,
          }}
        />
      </div>
    );
  }
}

export default reduxForm({
  form: 'assetsViewToolsGrid',
})(ToolsGrid);
